import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../api/axios';

const ResetPassword: React.FC = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [motDePasse, setMotDePasse] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (motDePasse.length < 8) { toast.error('Minimum 8 caractères'); return; }
    if (motDePasse !== confirm) { toast.error('Les deux mots de passe ne correspondent pas'); return; }
    setBusy(true);
    try {
      await api.post('/auth/reset-password', { token, motDePasse });
      toast.success('Mot de passe mis à jour');
      navigate('/login');
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Lien invalide ou expiré.');
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center">
          <p className="text-sm text-slate-600">Lien de réinitialisation invalide.</p>
          <Link to="/login" className="text-blue-600 font-semibold mt-4 inline-block">Retour</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
        <h1 className="text-2xl font-bold mb-4">Nouveau mot de passe</h1>
        <form onSubmit={submit} className="space-y-4">
          <input type="password" value={motDePasse} onChange={(e) => setMotDePasse(e.target.value)} required minLength={8}
                 placeholder="Nouveau mot de passe (8 caractères min.)"
                 className="w-full rounded-lg border border-slate-200 px-3 py-2 focus:outline-none focus:border-blue-500" />
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
                 placeholder="Confirmer"
                 className="w-full rounded-lg border border-slate-200 px-3 py-2 focus:outline-none focus:border-blue-500" />
          <button type="submit" disabled={busy}
                  className="w-full rounded-lg bg-blue-600 text-white font-semibold py-2.5 hover:bg-blue-700 disabled:opacity-50">
            {busy ? 'Enregistrement…' : 'Changer le mot de passe'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
